import _ from 'lodash'
import React from 'react'
import {renderSelf} from 'views/Shared'
import {Modal} from "antd";
import {BiSolidErrorAlt} from "react-icons/bi";

const createErrorDialog = ({
                               onOk,
                               error,
                               errorObj = {
                                   error_code: 'System error!',
                                   error: '-1',
                                   message: 'System error!',
                               },
                               translate = renderSelf,
                               ...props
                           }) => {
    const getErrors = (errors) => {
        if (typeof errors === 'object') {
            const array = Object.keys(errors || [])
            return (
                <ul>
                    {array.map((name, index) => {
                        if (typeof _.get(errors, name) === 'array') {
                            return (
                                <li key={index}>{`[${name}]: ${_.get(errors, name).join(", ")}`}</li>
                            )
                        }
                        return (
                            <li key={index}>{`[${name}]: ${_.get(errors, name)}`}</li>
                        )
                    })}
                </ul>
            )
        } else {
            return JSON.stringify(errors)
        }
    }
    Modal.confirm({
        icon: <BiSolidErrorAlt size={20} style={{color: 'var(--color-primary-500)'}} className="anticon"/>,
        className: 'custom-modal',
        title: typeof errorObj.error_code === 'string'
            ? errorObj.error_code
            : JSON.stringify(errorObj.error_code || errorObj.message),
        content: typeof errorObj.error === 'string'
            ? <span className="text-xs text-color-400 italic">{errorObj.error}</span>
            : <span className="text-xs text-color-400 italic">{getErrors(errorObj.error)}</span>,
        onOk,
        ...props,
    })
}


export const showErrorDialog = (translate) => ({error, errorObj, onOk, ...props}) =>
    createErrorDialog({
        onOk, error, errorObj, translate,
        ...props,
    })

export default createErrorDialog